import { Component as ComponentContainer } from '@styles/layout';
import { BaseComponent } from '@model/content';
import { ToursCallToBook } from '@components/call-to-book/ToursCallToBook';

export const ToursCallToBookContainer = (props: BaseComponent) => {
  const { tripType, destination } = props;

  if (destination && tripType) {
    return (
      <ComponentContainer>
        <ToursCallToBook {...props} destination={destination.display} tripType={tripType} />
      </ComponentContainer>
    );
  }
  return null;
};
